import ServicePageTemplate from './ServicePageTemplate';
import { btechBeInternshipProjectGuidanceConfig } from './trainingPageConfigs';

const BeBtechInternship = () => (
  <ServicePageTemplate {...btechBeInternshipProjectGuidanceConfig} />
);

export default BeBtechInternship;
